'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.useGetTypographyColorFromProps = void 0;

var react_1 = require('react');

var components_1 = require('../../../constants/components');

var useThemeContext_1 = require('../../../hooks/useThemeContext');

var useGetTypographyColorFromProps = function useGetTypographyColorFromProps(color) {
  if (color === void 0) {
    color = '';
  }

  var themeConfig = useThemeContext_1.useThemeContext().themeConfig;
  var TypographyColors = react_1.useMemo(
    function () {
      var _a;

      return (
        (_a = {}),
        (_a[components_1.TYPOGRAPHY_COLORS.primary1] = themeConfig.baseColors.primary1(1)),
        (_a[components_1.TYPOGRAPHY_COLORS.primary2] = themeConfig.baseColors.primary2(1)),
        (_a[components_1.TYPOGRAPHY_COLORS.secondary1] = themeConfig.baseColors.secondary1(1)),
        (_a[components_1.TYPOGRAPHY_COLORS.secondary2] = themeConfig.baseColors.secondary2(1)),
        (_a[components_1.TYPOGRAPHY_COLORS.success] = themeConfig.systemColors.success(1)),
        (_a[components_1.TYPOGRAPHY_COLORS.info] = themeConfig.systemColors.info(1)),
        (_a[components_1.TYPOGRAPHY_COLORS.warning] = themeConfig.systemColors.warning(1)),
        (_a[components_1.TYPOGRAPHY_COLORS.error] = themeConfig.systemColors.error(1)),
        (_a[components_1.TYPOGRAPHY_COLORS.main] = themeConfig.transparent[100]),
        (_a[components_1.TYPOGRAPHY_COLORS.description] = themeConfig.transparent[75]),
        (_a[components_1.TYPOGRAPHY_COLORS.caption] = themeConfig.transparent[50]),
        (_a[components_1.TYPOGRAPHY_COLORS.disabled] = themeConfig.transparent[25]),
        _a
      );
    },
    [themeConfig]
  );

  if (color in TypographyColors) {
    return TypographyColors[color];
  }

  return color;
};

exports.useGetTypographyColorFromProps = useGetTypographyColorFromProps;
